module.exports = __webpack_public_path__ + "media/assets/icons/quill/align-right-d5c6a0dd7ec2c4710c7fc12efa0d30c0.svg";